import { createStandardAction } from 'typesafe-actions';
import { FeedEventData } from '@tradingblock/types';

export const FEED_CLOSED = `@quotes/feed/closed`;
export const FEED_ERRORED = `@quotes/feed/errored`;
export const FEED_CONNECTED = `@quotes/feed/connected`;
export const feedClosed = createStandardAction(FEED_CLOSED)<FeedEventData>();
export const feedErrored = createStandardAction(FEED_ERRORED)<FeedEventData>();
export const feedConnected = createStandardAction(FEED_CONNECTED)();

export const SpreadsFeedActions = {
  spreadsFeedClosed: createStandardAction(FEED_CLOSED)<FeedEventData>(),
  spreadsFeedErrored: createStandardAction(FEED_ERRORED)<FeedEventData>(),
  spreadsFeedConnected: createStandardAction(FEED_CONNECTED)(),
};
